const roles: { [key: string]: string } = {
  network_admin: "admin",
  security_guard: "guard",
  host: "host",
  secondary_user: "secondary_host",
};

export default roles;
